/**
 * fissal.js — Constants for the Fissal page-transition overlay.
 *
 * Pure data; no side effects, no DOM access.
 */

export const FISSAL_TRANSITION_MSGS = [
  'Fissal is tuning his ears\u2026',
  'Calibrating the Dwemer array\u2026',
  'Consulting the trade scrolls\u2026',
  'Adjusting the brass clockwork\u2026',
  'Polishing the price lenses\u2026',
  'Routing through the relay\u2026',
  'Syncing with the guild network\u2026',
  'Rewinding the ticker tape\u2026',
  'Aligning the lunar instruments\u2026',
  'Sharpening the market quill\u2026',
  'Checking the price crystals\u2026',
  'Warming up the transmitter\u2026',
  'Fissal is on it \u2014 hold still\u2026',
  'The gears remember everything\u2026',
  'Just a moment, the wards are loading\u2026',
];
